import { render } from "./Motherboard.vue?vue&type=template&id=461827ae"
import script from "./Motherboard.vue?vue&type=script&lang=js"
export * from "./Motherboard.vue?vue&type=script&lang=js"

import "./Motherboard.vue?vue&type=style&index=0&id=461827ae&lang=css"

import exportComponent from "/data/vstsagent01/user/2766/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ui/Motherboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "461827ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('461827ae', __exports__)) {
    console.log('reload')
    api.reload('461827ae', __exports__)
  }
  
  module.hot.accept("./Motherboard.vue?vue&type=template&id=461827ae", () => {
    console.log('re-render')
    api.rerender('461827ae', render)
  })

}


export default __exports__